<template>
  <div class="slide" id="share" v-show="isVisibleSlide('share')">
    <div class="container">
      <h2>Thank you - just click below to share:</h2>
      <button @click="shareOnFacebook" class="facebook">Share on Facebook</button>
      <button @click="shareOnWhatsapp" class="whatsapp">Share on WhatsApp</button>
      <button @click="shareOnEmail" class="pink">Share on Email</button>
      <div class="share_preview">
        <div class="share_image">
          <img
            src="https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/patient-og.jpg?v=1552650068000"
          >
        </div>
        <div class="share_text">
          <h2>“No Dying Person Should Be Made To Suffer.” Add Your Name &gt;&gt;</h2>
          <h3>Join the public record of support for legalising assisted dying.</h3>
        </div>
      </div>
      <div style="margin-top:40px;">
        <button @click="gotoSlide('donate'), fbq('trackCustom', 'DonatePage')" class="grey">Skip</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Share",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  data() {
    return {};
  },
  methods: {
    shareOnFacebook() {
      var toShareUrl = window.location.href.split("?")[0];

      var shareURL =
        "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(toShareUrl);
      window.open(
        shareURL,
        "_blank",
        "toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250,top=300,left=300"
      );
      this.analytics("shared", "facebook");
      // eslint-disable-next-line
      fbq("trackCustom", "DonatePage");
      this.gotoSlide("donate");
    },
    shareOnWhatsapp() {
      var here =
        window.location.href.split("?")[0] +
        "?utm_source=whatsapp&utm_medium=share&utm_campaign=did-record";

      var shareText =
        "Hi - I've just added my name to Dignity in Dying's public record of support for legalising assisted dying. If you agree, add your name - it only takes ten seconds: " +
        here;

      var shareURL =
        "https://api.whatsapp.com/send?text=" + encodeURIComponent(shareText);
      window.open(shareURL, "_blank");
      this.analytics("shared", "whatsapp");
      // eslint-disable-next-line
      fbq("trackCustom", "DonatePage");
      this.gotoSlide("donate");
    },
    shareOnEmail() {
      console.log("test");
      window.location.href =
        "mailto:?subject=I've just added my name. Will you?&body=Hi - I've just added my name to Dignity in Dying's public record of support for legalising assisted dying. If you agree, add your name - it only takes ten seconds: " +
        window.location.href.split("?")[0] +
        "%0D%0A%0D%0AThanks.";
      this.analytics("shared", "email");
      // eslint-disable-next-line
      fbq("trackCustom", "DonatePage");
      this.gotoSlide("donate");
    }
  }
};
</script>
<style lang="scss">
.share_preview {
  max-width: 550px;
  width: 100%;
  margin-top: 30px;
  margin: 30px auto 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  @media screen and (max-width: 767px) {
    margin-top: 20px;
  }
  .share_image {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
  .share_text {
    padding: 15px;
    background: white;
    text-align: left;
    h2 {
      font-size: 17px;
      font-weight: normal;
      line-height: 1.64;
      margin: 0 0 5px;
    }
    h3 {
      font-size: 14px;
      line-height: 20px;
      margin: 0;
      font-weight: bold;
      font-family: "Sabon", Georgia, Times, "Times New Roman", serif;
    }
  }
}
</style>